import { createContext } from "react";

export const RootContext = createContext();
